import * as React from 'react';
import { useEffect, useCallback } from 'react';
import { UnControlled as ReactCodeMirror } from 'react-codemirror2';
import cancelEvent from '../../../../services/mini/cancelEvent';
import EditorSearch from '../../../components/EditorSearch/EditorSearch';

const CodeMirror = require('codemirror/lib/codemirror');

require('../../../../services/cm/customSearch');

type CodeEditorWithSearchProps = {
    editorId: string;
    searchKey: string;
    value: string;
    options: object;
    onBeforeChange: (editor, data, value) => void;
    onFocus: () => void;
    onSave: () => void;
}


const CodeEditorWithSearch = React.forwardRef<null, CodeEditorWithSearchProps>(
    (props, editorRef) => {
        const {
            editorId,
            searchKey,
            value,
            options,
            onBeforeChange,
            onFocus,
            onSave
        } = props;


        const onKeyDownCb = useCallback((e) => {
            const cm = (editorRef as any).current?.editor;
            if (cm && searchKey === editorId) {
                if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.which === 70) {
                    e.preventDefault();
                    cm.execCommand('replace');
                } else if ((e.ctrlKey || e.metaKey) && e.which === 70) {
                    e.preventDefault();
                    cm.execCommand('findPersistent');
                } else if (e.which === 27) {
                    cm.execCommand('closeSearch');
                } else if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.which === 71) {
                    e.preventDefault();
                    if (!e.target.parentNode?.parentNode?.classList?.contains('CodeMirror')) {
                        cm.execCommand('findPrev');
                    }
                } else if ((e.ctrlKey || e.metaKey) && e.which === 71) {
                    e.preventDefault();
                    if (!e.target.parentNode?.parentNode?.classList?.contains('CodeMirror')) {
                        cm.execCommand('findNext');
                    }
                }

                if (e.which === 83 && (e.ctrlKey || e.metaKey)) {
                    cancelEvent(e);
                    onSave();
                }
            }
        }, [editorId, editorRef, onSave, searchKey]);

        const getScriptEditorCmCb = useCallback(() => {
            return (editorRef as any).current?.editor;
        }, [editorRef]);

        const onFocusCb = useCallback(() => {
            onFocus();
        }, [onFocus]);


        const onChangeCb = useCallback((editor, data, value) => {
            onBeforeChange(editor, data, value);
            editor.execCommand('searchTextUpdate');
        }, [onBeforeChange]);

        useEffect(() => {
            const cm = (editorRef as any).current?.editor;
            if (cm) {
                cm.setValue(value);
            }
        }, []);

        useEffect(() => {
            window.addEventListener('keydown', onKeyDownCb);
            return () => window.removeEventListener('keydown', onKeyDownCb);
        }, [onKeyDownCb]);

        return <React.Fragment>
            <EditorSearch
                searchKey={editorId}
                getScriptEditorCm={getScriptEditorCmCb}
                allowReplace={true} />
            <ReactCodeMirror
                ref={editorRef}
                options={options}
                onChange={onChangeCb}
                onFocus={onFocusCb}
            />
        </React.Fragment>;
    });

export default CodeEditorWithSearch;